module.exports = __webpack_public_path__ + "static/screenshot_05@2x-24c0f46fbc83498f8878e56c68b8bbfc.png";